import React from "react";
import styled from "styled-components";

const waveAnalyzerImage = require("./../../assets/wave_analyzer1.png");

const WaveContainer = styled.section`
  width: 98vw;
  display: flex;
  justify-content: center;
  margin: 100px 0 120px 0;
  position: relative;

  @media (max-width: 900px) {
    margin: 80px 0 80px 0;
  }

  @media (max-width: 650px) {
    margin: 50px 0 60px 0;
  }
`;

const WaveInner = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  padding: 0 16px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 28px;
  }
`;

const Content = styled.div`
  flex: 1.1;
  display: flex;
  flex-direction: column;
`;

const Tagline = styled.p`
  color: #e88565;
  font-size: 14px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  font-family: "axiforma-light";
  margin: 0 0 8px 0;

  @media (max-width: 650px) {
    font-size: 12px;
  }
`;

const Title = styled.h2`
  color: #011638;
  font-size: 40px;
  font-weight: 400;
  margin: 0 0 4px 0;

  @media (max-width: 900px) {
    font-size: 34px;
  }

  @media (max-width: 650px) {
    font-size: 9vw;
  }
`;

const Subtitle = styled.p`
  color: #011638;
  font-size: 22px;
  font-weight: 400;
  margin: 0 0 18px 0;

  @media (max-width: 900px) {
    font-size: 20px;
  }

  @media (max-width: 650px) {
    font-size: 5vw;
  }
`;

const BodyText = styled.p`
  color: #657083;
  font-family: "axiforma-light";
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0.54px;
  line-height: 1.6;
  margin: 0 0 14px 0;

  @media (max-width: 650px) {
    font-size: 3.6vw;
  }
`;

const HighlightText = styled.p`
  color: #657083;
  font-family: "axiforma-light";
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0.54px;
  line-height: 1.6;
  margin: 0 0 18px 0;

  strong {
    color: #011638;
    font-weight: 400;
  }

  @media (max-width: 650px) {
    font-size: 3.6vw;
  }
`;

const Quote = styled.p`
  font-family: "axiforma-light";
  font-style: italic;
  font-size: 15px;
  color: #011638;
  margin: 0 0 16px 0;
  padding-left: 14px;
  border-left: 2px solid #e88565;

  @media (max-width: 650px) {
    font-size: 3.6vw;
  }
`;

const ImageWrapper = styled.div`
  flex: 0.9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const CircleBg = styled.div`
  position: absolute;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background-color: #e886659b;
  z-index: -1;
  transform: translate(0px, 10px);

  @media (max-width: 1200px) {
    width: 460px;
    height: 460px;
  }

  @media (max-width: 900px) {
    width: 420px;
    height: 420px;
    transform: translate(0, 0);
  }

  @media (max-width: 600px) {
    width: 250px;
    height: 250px;
    background-color: #0116387c;
  }
`;

const ImageScale = styled.div`
  transform: scale(0.95);

  @media (max-width: 1200px) {
    transform: scale(0.9);
  }

  @media (max-width: 1000px) {
    transform: scale(0.85);
  }

  @media (max-width: 900px) {
    transform: scale(0.95);
  }

  @media (max-width: 650px) {
    transform: scale(0.9);
  }
`;

const Machine = () => {
  const isMobile = window.innerWidth < 700;
  return (
    <WaveContainer id="machine">
      <WaveInner>
        <Content>
          <Tagline>Zaawansowana diagnostyka wzroku</Tagline>
          <Title>Wave Analyzer Medica 700</Title>
          <Subtitle>Najnowocześniejsze badanie wzroku w regionie</Subtitle>

          <BodyText>
            W naszym zakładzie korzystamy z jednego z najbardziej zaawansowanych
            urządzeń diagnostycznych dostępnych na świecie – Wave Analyzer
            Medica 700. To innowacyjna maszyna, która w zaledwie kilkadziesiąt
            sekund wykonuje pełny pakiet badań oczu, łącząc funkcje wielu
            specjalistycznych urządzeń w jednym.
          </BodyText>

          <HighlightText>
            W zaledwie <strong>90 sekund</strong> dowiesz się, jaką dokładnie
            masz wadę wzroku, czy Twoje oczy pracują prawidłowo oraz czy
            istnieje ryzyko takich chorób jak jaskra, zaćma czy stożek rogówki.
            Urządzenie sprawdza także jakość widzenia w dzień i w nocy oraz
            wychwytuje subtelne nieprawidłowości, których nie da się zauważyć
            przy tradycyjnym badaniu tablicy. Dzięki temu można szybko ocenić
            stan zdrowia oczu i reagować, zanim pojawią się poważniejsze objawy.
          </HighlightText>

          <Quote>„Jedno badanie – pełen obraz zdrowia Twojego wzroku.”</Quote>
        </Content>

        <ImageWrapper>
          <CircleBg />
          <ImageScale>
            <img
              src={waveAnalyzerImage}
              width={isMobile ? 220 : 420}
              height={isMobile ? 220 : 420}
              alt="Wave Analyzer Medica 700"
            />
          </ImageScale>
        </ImageWrapper>
      </WaveInner>
    </WaveContainer>
  );
};

export default Machine;
